import { useNormalizedMarketsStore } from '../../state/normalizedMarkets.store';
import { useEntitiesStore } from '../../state/entities.store';
import { getGameLine } from '../../utils/gameLine';

/** Read imperatively so price ticks do not re-render a card just to keep analytics current. */
export const readTapContext = (marketGroupId: string) => {
  const group = useNormalizedMarketsStore.getState().normalizedMarketGroupsById.get(marketGroupId);
  const event = group?.eventId
    ? useEntitiesStore.getState().eventsById.get(group.eventId)
    : undefined;

  return {
    group,
    gameId: group?.eventId,
    league: group?.subCategory,
    gameState: getGameLine(event, Date.now()).isLive ? ('live' as const) : ('pregame' as const),
  };
};
